module.exports = __webpack_public_path__ + "img/hb.3f5cb20f.png";